<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.990234375,0.9899999499320984C13.990234375,0.9899999499320984,1.990234375,0.9899999499320984,1.990234375,0.9899999499320984C1.440234375,0.9899999499320984,0.990234375,1.4399999499320983,0.990234375,1.9899999499320984C0.990234375,2.2699999499320986,1.100234375,2.5199999499320986,1.280234375,2.6999999499320984C1.280234375,2.6999999499320984,5.990234375,7.409999949932098,5.990234375,7.409999949932098C5.990234375,7.409999949932098,5.990234375,13.999999949932098,5.990234375,13.999999949932098C5.990234375,14.549999949932099,6.440234375,14.999999949932098,6.990234375,14.999999949932098C7.270234375,14.999999949932098,7.520234375,14.889999949932099,7.700234375,14.709999949932099C7.700234375,14.709999949932099,9.700234375,12.709999949932099,9.700234375,12.709999949932099C9.880234375,12.529999949932098,9.990234375,12.279999949932098,9.990234375,11.999999949932098C9.990234375,11.999999949932098,9.990234375,7.409999949932098,9.990234375,7.409999949932098C9.990234375,7.409999949932098,14.700234375,2.6999999499320984,14.700234375,2.6999999499320984C14.880234375,2.5199999499320986,14.990234375,2.2699999499320986,14.990234375,1.9899999499320984C14.990234375,1.4399999499320983,14.540234375,0.9899999499320984,13.990234375,0.9899999499320984C13.990234375,0.9899999499320984,13.990234375,0.9899999499320984,13.990234375,0.9899999499320984Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Filter',
} as DefineComponent
</script>
